import React, { useMemo, useState } from "react";
import { BsCaretDownFill, BsCaretRightFill, BsPeople, BsPerson, BsPlusCircle, BsCheckCircle } from "react-icons/bs";
import {FaCalendarPlus, FaFemale, FaMars, FaVenus} from "react-icons/fa";

const PatientKPIs = ({ patients = [], showKPIs = true }) => {
    const [showKPI, setShowKPI] = useState(showKPIs);

    const kpis = useMemo(() => {
        const totalPatients = patients.length;
        const males = patients.filter(p => p.gender === "male").length;
        const females = patients.filter(p => p.gender === "female").length;

        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        const newPatients = patients.filter(p => {
            if (!p.createdAt) return false;
            const regDate = new Date(p.createdAt);
            return regDate >= oneMonthAgo;
        }).length;

        const solvedPatients = patients.filter(p => p.medicalHistory && p.medicalHistory.solved).length;

        return {
            totalPatients,
            males,
            females,
            newPatients,
            solvedPatients
        };
    }, [patients]);

    const formatNumber = (value) => {
        if (typeof value === 'number') {
            return value.toLocaleString();
        }
        return value;
    };

    const toggleKPI = () => setShowKPI(prev => !prev);

    const kpiCards = [
        {
            title: "Total",
            value: kpis.totalPatients,
            icon: <BsPeople />,
            iconColor: "#f5f2e8"
        },
        {
            title: "Males",
            value: kpis.males,
            icon: <FaMars  />,
            iconColor: "#e8f4fd"
        },
        {
            title: "Females",
            value: kpis.females,
            icon: <FaVenus  />,
            iconColor: "#fde8f4"
        },
        {
            title: "New",
            value: kpis.newPatients,
            icon: <FaCalendarPlus  />,
            iconColor: "#e8f5e8"
        },
        {
            title: "Solved",
            value: kpis.solvedPatients,
            icon: <BsCheckCircle />,
            iconColor: "#f0e8fd"
        }
    ];

    return (
        <>
            {/* <div className="d-flex align-items-center justify-content-between mb-3 mt-4">
                <div className="d-flex align-items-center">
                    <h5 className="mb-0 me-3">Dashboard / Patients</h5>
                    <button onClick={toggleKPI} className="btn text-primary p-0">
                        {showKPI ? "Hide KPI " : "Show KPI "}
                        {showKPI ? <BsCaretDownFill size={12} /> : <BsCaretRightFill size={12} />}
                    </button>
                </div>
            </div> */}

            {showKPI && (
                <div className="row gy-3 introbx_row">
                    {kpiCards.map((kpi, index) => (

                        <div key={index} className="col">
                            <div className="d-flex align-items-center gap-2 p-3 rounded-10 shadow-sm">
                                <div className="icon flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '2rem', height: '2rem', backgroundColor: '#E4E4FF', color: '#8381FF' }}>
                                    <span className="d-block material-symbols-outlined fs-lg">{kpi.icon}</span>
                                </div>
                                <div className="info flex-fill">
                                    <p className="fs-sm text-gray mb-0">{kpi.title}</p>
                                    <p className="lh-1 fw-semibold">{formatNumber(kpi.value)}</p>
                                </div>
                            </div>
                        </div>

                    ))}
                </div>
            )}
        </>
    );
};

export default PatientKPIs;